import { Injectable } from '@angular/core';
import { galileo } from '@galileo/galileo-web-sdk';
import { isDevelopmentEnv } from '../shared/utils';
import { from } from 'rxjs';
import { PROJECT_NAME_IMDE, SG_GALILEO_VARIABLES } from '../common/constants';

@Injectable({
  providedIn: 'root'
})
export class ServiceAccessEnableToggleService {
  private galileo;

  constructor() {
    this.initialize();
  }

  private initialize() {
    this.galileo = galileo;
    const env = isDevelopmentEnv(window?.location?.hostname) ? 'dev' : 'prd';
    this.galileo.setEnvironment(env);
  }

  private getBool(variable: string, tags: Record<string, any>, defaultValue: boolean) {
    const response = this.galileo.getBool(variable, tags, defaultValue);
    return from(response);
  }

  serviceAccessEnableCheck(tags: Record<string, any> = {}) {
    return this.getBool(`${PROJECT_NAME_IMDE}/${SG_GALILEO_VARIABLES.is_captain_supply_gate_admin_portal_enabled}`, tags, false);
  }
}
